define('SageDotCom/Components/ProductCardPriceSelector',["jquery", "eventManager","SageDotCom/Components/ProductCard/ProductCardSelection"],
    function ($, eventManager, productCardSelection) {

        function ProductCardPriceSelector(scope) {
            ///<summary>Initialize a new instance of FlexBox. Subscribe to messages which are passed to current instance.</summary>

            var self = this;
            Object.defineProperty(this, "$scope", { enumerable: true, value: $(scope) });

            var tooltipDestroyTimeout = undefined;
            var tooltipCreateTimeout = undefined;
            $(scope).find('.price-ddl').on('change', function () {
                clearTimeout(tooltipDestroyTimeout);
                clearTimeout(tooltipCreateTimeout);
                tooltipDestroyTimeout = setTimeout(function () {
                    $('.sage-product-card-tooltip-icon').each(function () {
                        $(this).tooltip('destroy');
                    });
                }, 10);

                productCardSelection.setProductCardValue("dropdown",$(scope).find(":selected").index(), $(scope).closest('.sage-product-card,.sage-product-card-alt').attr("data-pid"));

                var eventName = 'productCardPriceChange:' + $(scope).closest('.sage-product-card,.sage-product-card-alt').parent()[0].id;
                eventManager.trigger(eventName, $(scope).closest('.sage-product-card,.sage-product-card-alt').parent());
                eventManager.trigger("product card detail event", "dropdown", "", false, "", $(scope).find(":selected").index());


                tooltipCreateTimeout = setTimeout(function () {
                    $('.sage-product-card-tooltip tr').each(function () {
                        if ($(this).find('span').is(':empty')) {
                            $(this).css('display', 'none');
                        } else {
                            $(this).css('display', '');
                        }
                    });

                    $('.sage-product-card-tooltip-icon').each(function () {
                        $(this).tooltip(
                            {
                                html: true,
                                placement: 'bottom',
                                title: $('#' + $(this).data('tip')).html()
                            });
                    });
                }, 500);
            });
        }

        ProductCardPriceSelector.init = function init(args) {
            return args.IsEditorEditing === true
                ? null
                : new ProductCardPriceSelector(args.scope);
        };

        return ProductCardPriceSelector;
    });
